import { render, staticRenderFns } from "./Invalid.vue?vue&type=template&id=2af50148&"
import script from "./Invalid.vue?vue&type=script&lang=js&"
export * from "./Invalid.vue?vue&type=script&lang=js&"
import style0 from "./Invalid.vue?vue&type=style&index=0&id=2af50148&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports